import React from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, Text, HStack, Image, Button, useStyleConfig} from '@chakra-ui/react'
import {TextTitleDescription} from '../../text-title-description'
import {ChevronRight} from '../../../icons/arrows'
import {remCalc} from '../../../../theme/_utils'
import CustomLink from '../../../custom-link'
import {useGetCategoriesData} from '../../../../custom-api/hooks/use-get-categories-data'
import {getGlobalLink} from '../../../../utils/contentstack-utils'
import useDamImage from '../../../../custom-hooks/use-dam-image'

const PromoSlideCard = ({title, bodyCopy, button, url, alt, image}) => {
    const styles = useStyleConfig('PromoSlider')
    const categoryData = useGetCategoriesData()
    const {url: ctaUrl, label: ctaLabel, isAbsolute} = getGlobalLink(button, categoryData)
    const {url: imageUrl} = useDamImage(image)

    // const handleRedirect = (e) => {
    //     e.preventDefault()
    //     if (cta && cta?.href) {
    //         isExternalUrl ? window.open(cta.href, '_blank') : navigate(cta.href)
    //     }
    // }

    const imageToDisplay = imageUrl || url

    return (
        <CustomLink isExternal={isAbsolute} href={ctaUrl} data-testid="promo-slide-card-link">
            <Flex sx={styles.sliderContainer} data-testid={`swiper-slide-${title || 'container'}`}>
                <Box sx={styles.imageContainer} data-testid="promo-slider-image-container">
                    <Image
                        src={imageToDisplay}
                        alt={alt}
                        loading="lazy"
                        w="100%"
                        height="100%"
                        objectFit="cover"
                        data-testid="promo-slider-image"
                    />
                </Box>
                <Flex sx={styles.contentContainer}>
                    <TextTitleDescription
                        title={title}
                        color="text.inverse"
                        textStyle="head-large"
                        weight="500"
                        titleSpacing={remCalc(24)}
                        childrenTextColor="text.inverse"
                        childrenTextStyle="body-large"
                        mb={remCalc(24)}
                    >
                        {bodyCopy}
                    </TextTitleDescription>
                    {ctaLabel && (
                        <Button variant="inverse" aria-label={ctaLabel} tabIndex={0}>
                            <HStack gap={remCalc(10)}>
                                <Text as="span" color="text.inverse">
                                    {ctaLabel}
                                </Text>
                                <ChevronRight
                                    aria-label="right icon"
                                    backgroundColor="background.default"
                                    borderRadius="50%"
                                />
                            </HStack>
                        </Button>
                    )}
                </Flex>
            </Flex>
        </CustomLink>
    )
}

PromoSlideCard.propTypes = {
    title: PropTypes.string,
    bodyCopy: PropTypes.string,
    button: PropTypes.object,
    url: PropTypes.string,
    alt: PropTypes.string,
    image: PropTypes.object,
}

export default PromoSlideCard
